export default __webpack_public_path__ + "static/media/single-project-page-05-img-10.064f2cd2.png";